var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGeolocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 27 27"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  opacity: 0.776,
  transform: "translate(.312 .794)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.031 12.261h-4.148a8.81 8.81 0 0 0-7.899-7.899V.142h-1.71v4.22a8.81 8.81 0 0 0-7.9 7.9H.226v1.71h4.148a8.81 8.81 0 0 0 7.899 7.899v4.22h1.71v-4.22a8.81 8.81 0 0 0 7.9-7.899h4.148v-1.71zm-12.903 7.942a7.094 7.094 0 0 1-7.085-7.086 7.094 7.094 0 0 1 7.085-7.086 7.094 7.094 0 0 1 7.086 7.086 7.094 7.094 0 0 1-7.086 7.086"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.128,
  cy: 13.117,
  r: 3.293
}))));
export default SvgGeolocation;